export default {
  placeholder: 'Chargenstatus auswählen',
};
